import Rest from '../rest'

export default class Action extends Rest {
	constructor() {
		super('/funnel/actions')
	}
}
